import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency = 'SEK'): string {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency,
  }).format(amount)
}

export function formatTime(date: Date | string): string {
  return new Intl.DateTimeFormat('sv-SE', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date))
}

export function formatDate(date: Date | string): string {
  return new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date))
}

export function formatRelativeTime(date: Date | string): string {
  const now = new Date()
  const then = new Date(date)
  const diffMs = now.getTime() - then.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins}m ago`
  if (diffHours < 24) return `${diffHours}h ago`
  return `${diffDays}d ago`
}

export function openInMaps(address: string, lat?: number, lng?: number): void {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  
  if (lat && lng) {
    if (isIOS) {
      window.open(`maps://maps.apple.com/?daddr=${lat},${lng}`)
    } else {
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`)
    }
  } else {
    const encoded = encodeURIComponent(address)
    if (isIOS) {
      window.open(`maps://maps.apple.com/?daddr=${encoded}`)
    } else {
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${encoded}`)
    }
  }
}
